import * as React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { ProfilePostLeftSide } from './ProfilePostLeftSide/ProfilePostLeftSide';
import { ProfilePostRightSide } from './ProfilePostRightSide/ProfilePostRightSide';

import './ProfilePosts.scss'
export interface IProfilePostsProps {
}

export function ProfilePosts(props: IProfilePostsProps) {



    const filterOptionsStyles = "px-3 md:px-4 2xl:px-5 py-2 md:py-3 mr-3 lg:mr-5 rounded-md flex justify-center items-center filter_option  border-2 bg-white dark:bg-transparent dark:border-[#6561B1] text-[#6561B1] cursor-pointer select-none transition-all";
    return (
        <div className="profile_post_main_box">

            <div className="relative ">
                <div className="xl:hidden right_arrow_bg h-full xs:w-8 sm:w-12 absolute right-0 flex justify-end items-center"></div>

                <ScrollContainer
                    nativeMobileScroll={true}
                    horizontal={true}
                    className="scroll-container pr-12 xl:px-0 xs:mt-5 lg:mt-8 profile_posts_filter_options_box flex 
                    justify-start items-center overflow-auto ">

                    <input type="checkbox" name="post_fillter_Create" id="post_fillter_Create" className="hidden" />
                    <label htmlFor="post_fillter_Create">
                        <div className={filterOptionsStyles}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-[12px] md:w-[15px]" viewBox="0 0 19.167 19.167">
                                <g id="Group_1083" data-name="Group 1083" transform="translate(-36 -18)">
                                    <path id="Path_556" data-name="Path 556" d="M36.009,31.993a.562.562,0,0,0,.455.651l2.492.439-1.57-8.9Z" transform="translate(0 -0.257)" fill="#6561B1" />
                                    <path id="Path_557" data-name="Path 557" d="M39.079,18.009a.562.562,0,0,0-.653.455l-.6,3.377,11.331-2Z" transform="translate(-0.076 0)" fill="#6561B1" />
                                    <path id="Path_558" data-name="Path 558" d="M55.264,34.273,52.924,21a.562.562,0,0,0-.651-.455L39,22.886a.562.562,0,0,0-.455.651l2.34,13.272a.562.562,0,0,0,.651.456l13.272-2.34a.561.561,0,0,0,.456-.65Zm-13.726-6.7a.561.561,0,0,1,.455-.65l8.848-1.56a.561.561,0,1,1,.2,1.106l-8.848,1.56a.561.561,0,0,1-.651-.455Zm7.329,3.839-5.9,1.04a.561.561,0,1,1-.2-1.106l5.9-1.04a.562.562,0,0,1,.2,1.106Zm2.559-2.732-8.848,1.56a.57.57,0,0,1-.1.009.562.562,0,0,1-.1-1.115l8.848-1.56a.562.562,0,1,1,.195,1.106Z" transform="translate(-0.106 -0.106)" fill="#6561B1" />
                                </g>
                            </svg>
                            <p className="text-sm ml-3">Create</p>
                        </div>
                    </label>


                    <input type="checkbox" name="post_filter_Commit" id="post_filter_Commit" className="hidden" />
                    <label htmlFor="post_filter_Commit">
                        <div className={filterOptionsStyles}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-[12px] md:w-[15px]" viewBox="0 0 19.167 19.167">
                                <g id="Group_1083" data-name="Group 1083" transform="translate(-36 -18)">
                                    <path id="Path_556" data-name="Path 556" d="M36.009,31.993a.562.562,0,0,0,.455.651l2.492.439-1.57-8.9Z" transform="translate(0 -0.257)" fill="#6561B1" />
                                    <path id="Path_557" data-name="Path 557" d="M39.079,18.009a.562.562,0,0,0-.653.455l-.6,3.377,11.331-2Z" transform="translate(-0.076 0)" fill="#6561B1" />
                                    <path id="Path_558" data-name="Path 558" d="M55.264,34.273,52.924,21a.562.562,0,0,0-.651-.455L39,22.886a.562.562,0,0,0-.455.651l2.34,13.272a.562.562,0,0,0,.651.456l13.272-2.34a.561.561,0,0,0,.456-.65Zm-13.726-6.7a.561.561,0,0,1,.455-.65l8.848-1.56a.561.561,0,1,1,.2,1.106l-8.848,1.56a.561.561,0,0,1-.651-.455Zm7.329,3.839-5.9,1.04a.561.561,0,1,1-.2-1.106l5.9-1.04a.562.562,0,0,1,.2,1.106Zm2.559-2.732-8.848,1.56a.57.57,0,0,1-.1.009.562.562,0,0,1-.1-1.115l8.848-1.56a.562.562,0,1,1,.195,1.106Z" transform="translate(-0.106 -0.106)" fill="#6561B1" />
                                </g>
                            </svg>
                            <p className="text-sm ml-3">Commit</p>
                        </div>
                    </label>


                </ScrollContainer>
            </div>





            {/* -----------Left and right sections under the filter options----------- */}
            <div className="xs:flex-col xl:flex-row flex justify-between items-start my-5">

                <ProfilePostLeftSide />
                <ProfilePostRightSide />

            </div>


        </div>
    );
}
